import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-intersim',
  templateUrl: './intersim.component.html',
  styleUrls: ['./intersim.component.scss']
})
export class IntersimComponent implements OnInit {

  exposition: CardContent = {
    title: 'InterSim',
    subtitle: 'Individual- and Network-Based Simulation of Outbreaks and Interventions',
    image_source: 'assets/images/InterSim.PNG',
  };

  information: CardContent = {
    title: 'Project Info',
    sections: [
      '<h4>Partners</h4>University of Tübingen',
      '<h4>Methods</h4>Stochastic Individual-based Modelling',
      '<h4>Technology / Skills</h4>Java, Swing',
      '<h4>Term</h4>2004',
    ]
  };


  constructor() { }

  ngOnInit(): void {
  }

}
